import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-0 mb-0" }, "Persönliche Daten", -1)
const _hoisted_3 = { class: "d-flex align-items-center mt-3 mb-2" }
const _hoisted_4 = { class: "pe-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("small", null, "oder als Gast bestellen:")
], -1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "checkout-guest-input-prename",
  class: "form-label"
}, "Vorname", -1)
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "checkout-guest-input-surname",
  class: "form-label"
}, "Nachname", -1)
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "checkout-guest-input-email",
  class: "form-label"
}, "E-Mail-Adresse", -1)
const _hoisted_15 = {
  key: 0,
  class: "bf-field-errors"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("li", { class: "bf-field-errors__error" }, "Format der E-Mail-Adresse ist ungültig.", -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "checkout-guest-input-email-confirmation",
  class: "form-label"
}, "E-Mail-Adresse wiederholen", -1)
const _hoisted_20 = {
  key: 0,
  class: "bf-field-errors"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("li", { class: "bf-field-errors__error" }, "Muss mit der E-Mail-Adresse übereinstimmen.", -1)
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldError = _resolveComponent("FieldError")!
  const _component_LoginModal = _resolveComponent("LoginModal")!

  return (!_ctx.loggedIn)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", {
              href: "#",
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.loginModalShown = true), ["prevent"]))
            }, "Anmelden")
          ]),
          _hoisted_5
        ]),
        _createElementVNode("form", null, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: _normalizeClass(["form-control", {'is-invalid': _ctx.validationErrors.prename || false}]),
                  id: "checkout-guest-input-prename",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.prename) = $event)),
                  maxlength: "64"
                }, null, 2), [
                  [
                    _vModelText,
                    _ctx.form.prename,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _createVNode(_component_FieldError, {
                  errors: _ctx.validationErrors.prename || []
                }, null, 8, ["errors"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: _normalizeClass(["form-control", {'is-invalid': _ctx.validationErrors.surname || false}]),
                  id: "checkout-guest-input-surname",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.surname) = $event)),
                  maxlength: "64"
                }, null, 2), [
                  [
                    _vModelText,
                    _ctx.form.surname,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _createVNode(_component_FieldError, {
                  errors: _ctx.validationErrors.surname || []
                }, null, 8, ["errors"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              type: "email",
              class: _normalizeClass(["form-control", {'is-invalid': _ctx.validationErrors.email || false || (_ctx.showEmailError && _ctx.form.email && !_ctx.emailValid)}]),
              id: "checkout-guest-input-email",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.email) = $event)),
              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showEmailError = true))
            }, null, 34), [
              [
                _vModelText,
                _ctx.form.email,
                void 0,
                { trim: true }
              ]
            ]),
            _createVNode(_component_FieldError, {
              errors: _ctx.validationErrors.email || []
            }, null, 8, ["errors"]),
            (_ctx.showEmailError && _ctx.form.email && !_ctx.emailValid)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_15, _hoisted_17))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _withDirectives(_createElementVNode("input", {
              type: "email",
              class: _normalizeClass(["form-control", {'is-invalid': _ctx.validationErrors.email_confirmation || false || (_ctx.showEmailConfirmationError && _ctx.form.email_confirmation && _ctx.form.email_confirmation !== _ctx.form.email)}]),
              id: "checkout-guest-input-email-confirmation",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.email_confirmation) = $event)),
              onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showEmailConfirmationError = true))
            }, null, 34), [
              [
                _vModelText,
                _ctx.form.email_confirmation,
                void 0,
                { trim: true }
              ]
            ]),
            _createVNode(_component_FieldError, {
              errors: _ctx.validationErrors.email_confirmation || []
            }, null, 8, ["errors"]),
            (_ctx.showEmailConfirmationError && _ctx.form.email_confirmation && _ctx.form.email_confirmation !== _ctx.form.email)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_20, _hoisted_22))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_LoginModal, {
          shown: _ctx.loginModalShown,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loginModalShown = false)),
          onLogin: _cache[8] || (_cache[8] = () => {})
        }, null, 8, ["shown"])
      ]))
    : _createCommentVNode("", true)
}